"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invoice = void 0;
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const InvoiceTitle_1 = __importDefault(require("./InvoiceTitle"));
const BillTo_1 = __importDefault(require("./BillTo"));
const InvoiceNo_1 = __importDefault(require("./InvoiceNo"));
const InvoiceItemsTable_1 = __importDefault(require("./InvoiceItemsTable"));
const InvoiceResume_1 = __importDefault(require("./InvoiceResume"));
const InvoiceFooter_1 = __importDefault(require("./InvoiceFooter"));
const styles = renderer_1.StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft: 60,
        paddingRight: 60,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
});
const Invoice = ({ invoice }) => (react_1.default.createElement(renderer_1.Document, null,
    react_1.default.createElement(renderer_1.Page, { size: "A4", style: styles.page },
        react_1.default.createElement(InvoiceTitle_1.default, { title: "Facture" }),
        react_1.default.createElement(InvoiceNo_1.default, { invoice: invoice }),
        react_1.default.createElement(BillTo_1.default, { invoice: invoice }),
        react_1.default.createElement(InvoiceItemsTable_1.default, { invoice: invoice }),
        react_1.default.createElement(InvoiceResume_1.default, { invoice: invoice }),
        react_1.default.createElement(InvoiceFooter_1.default, { invoice: invoice }))));
exports.Invoice = Invoice;
